<template>
  <div>
    <h2>{{ msg }}</h2>
	<h2>You seem lost.</h2>
  </div>
</template>
<script>
export default {
	name: 'error',
	data () {
		return {
			msg: '404!',
		}
	}
}
</script>
